import { Module } from 'vuex';
import { RootState } from '@/types/store';

import state from '@/store/modules/instant/state';
import actions from '@/store/modules/instant/action';
import mutations from '@/store/modules/instant/mutations';
import getters from '@/store/modules/instant/getters';
import { instantLottoState } from '@/types/instant';

const lotto: Module<instantLottoState, RootState> = {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
};

export default lotto;
